// @ts-nocheck
import { AccordionPresentationProps } from "@insite/mobius/Accordion";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { CheckboxStyle } from "@insite/mobius/Checkbox";
import { StyledButton } from "@insite/mobius/Clickable/Clickable";
import { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { RadioStyle } from "@insite/mobius/Radio";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { TagWrapperProps } from "@store/Library/Components/Toolkit/TagWrapper";
import { formSmallGridProps } from "@store/Themes/common/props/form";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export const tableGetEllipsisCellProps = (width: number): DataTableCellProps => ({
    css: css`
        > ${StyledButton}, > ${TypographyStyle}, > ${TypographyStyle} > ${StyledButton} {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: block;
            max-width: ${pxToRem(width)};
        }

        > ${StyledButton} {
            display: inline-block;
        }
    `,
});

export const tableRemoveEllipsisCellProps = (): DataTableCellProps => ({
    css: css`
        > ${StyledButton}, > ${TypographyStyle} {
            overflow: visible;
            white-space: inherit;
            max-width: none;
        }
    `,
});

export interface TableProps {
    wrapper?: InjectableCss;
    dataTable?: DataTableProps;
    selectionCell?: DataTableCellProps;
    amountHeader?: DataTableHeaderProps;
    amountCell?: DataTableCellProps;
    buttonHeader?: DataTableHeaderProps;
    buttonCell?: DataTableCellProps;
    tightHeader?: DataTableHeaderProps;
    tightCell?: DataTableCellProps;
    button?: ButtonPresentationProps;
}

export const tableProps: TableProps = {
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
            overflow-x: auto;
        `,
    },
    dataTable: {},
    selectionCell: {
        tight: true,
        css: css`
            text-align: center;
            line-height: 1;

            ${CheckboxStyle} {
                display: flex;

                [role="checkbox"] {
                    margin: 0;

                    + label {
                        padding: 0;
                    }
                }
            }

            ${RadioStyle} {
                display: flex;

                label {
                    font-size: 0;
                    color: transparent;

                    &::before,
                    &::after {
                        margin: 0;
                    }
                }
            }
        `,
    },
    amountHeader: {
        tight: true,
        css: css`
            text-align: right;

            > ${StyledButton} {
                justify-content: flex-end;
            }
        `,
    },
    amountCell: {
        tight: true,
        css: css`
            text-align: left;
        `,
    },
    buttonHeader: { tight: true },
    buttonCell: {
        tight: true,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    tightHeader: { tight: true },
    tightCell: {
        tight: true,
        css: css`
            padding-top: 0;
            padding-bottom: 0;
        `,
    },
    button: {
        color: "primary",
        sizeVariant: "small",
        css: css`
            ${x => x.theme.button.primary.css}
            position: relative;
            min-width: 0;
        `,
    },
};

export interface TableFilterProps {
    wrapper?: InjectableCss;
    accordion?: AccordionPresentationProps;
    formGridContainer?: GridContainerProps;
    clearButton?: ButtonPresentationProps;
    tagWrapper?: TagWrapperProps;
}

export const tableFilterProps: TableFilterProps = {
    wrapper: {
        css: css`
            ${x => spacingStyles(null, x.theme.design.typography.spacing.large)}
        `,
    },
    accordion: {
        mergeCss: true,
        css: css`
            ${x => spacingStyles(null, x.theme.design.typography.spacing.base)}
        `,
    },
    formGridContainer: formSmallGridProps.gridContainer,
    clearButton: { variant: "secondary" },
};
